module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "dialog": "modal-m"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Credit Note Reason")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4 min-height"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.getChargeBackReason,
      "disabled": _vm.getIsChargeBackReasonsLoading,
      "label": "label",
      "placeholder": "Select reason"
    },
    model: {
      value: (_vm.selectedReason),
      callback: function($$v) {
        _vm.selectedReason = $$v
      },
      expression: "selectedReason"
    }
  }), _vm._v(" "), (_vm.$v.selectedReason.$invalid) ? _c('div', {
    staticClass: "mt-1 messages error"
  }, [(!_vm.$v.selectedReason.required) ? _c('span', [_vm._v("Reason is required")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-0",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end pb-3 pr-4"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    class: {
      'disabled notAllowed': !_vm.selectedReason
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmClick
    }
  }, [(!_vm.getIsChargeBackReasonsLoading) ? _c('span', [_vm._v("Confirm")]) : _c('div', [_c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0e5f1957", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5f1957"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/InvoiceCancellation.vue
// module id = 1551
// module chunks = 0